// extracted by mini-css-extract-plugin
export var article = "TopNews-module--article--a2795";
export var articleTitle = "TopNews-module--article-title--e62bb";
export var bg = "TopNews-module--bg--c5e13";
export var container = "TopNews-module--container--566eb";
export var date = "TopNews-module--date--35fa7";
export var list = "TopNews-module--list--0325e";
export var title = "TopNews-module--title--29fb9 default-module--font-bold--e6812";